import { useTranslation } from "react-i18next";
import { Tooltip, Typography } from "antd";
import { showProductsListInfo, totalPaymentTooltip, totalPayment } from "../helper";
import { formatCurrency } from "@salespark/toolkit";

const { Text } = Typography;

const OtherProducts = ({ mainProduct, otherProducts, colSize, selectedOffer, viewDetailedPrices, isExternalManagement, hasCoupon, coupon }) => {
  const { t } = useTranslation();
  return (
    <div className="pricing-card">
      <div className="pricing-main">
        <div className="product-price">
          <div className="name">{mainProduct.name}</div>
          <div className="price">{showProductsListInfo(selectedOffer, mainProduct, hasCoupon, t)}</div>
        </div>

        {/* Show only if product isnt external management */}
        {viewDetailedPrices && !isExternalManagement && (
          <div className="price-details">
            <div className="price-detail">
              <Text className="price-detail-title">{t("otherProducts.priceLabel")}</Text>
              <Text className="price-detail-value">{formatCurrency(selectedOffer?.price_details.price_wo_vat)}</Text>
            </div>
            <div className="price-detail">
              <Text className="price-detail-title">{t("otherProducts.vatLabel", { vat: selectedOffer?.price_details.vat_tax })}</Text>
              <Text className="price-detail-value">{formatCurrency(selectedOffer?.price_details.vat_value)}</Text>
            </div>
            {colSize !== "xs" && (
              <div className="price-detail">
                <Text className="price-detail-title">{t("otherProducts.totalLabel")}</Text>
                <Text className="price-detail-value">{formatCurrency(selectedOffer?.price)}</Text>
              </div>
            )}
          </div>
        )}
        {selectedOffer?.n_payments > 1 && hasCoupon !== true && (
          <div className="installments_disclaimer">
            <Tooltip title={totalPaymentTooltip(selectedOffer, coupon, t)}>
              <Text className="text">{t("otherProducts.installmentsDisclaimer", { total: totalPayment(selectedOffer, coupon) })}</Text>
            </Tooltip>
          </div>
        )}
      </div>

      <div className="pricing-multiples">
        {otherProducts?.map((product) => {
          return (
            <div key={product.offer_id}>
              <div className="pricing-multiples">
                <div className="product-price">
                  <div className="name">{product.name}</div>
                  <div className="price">{showProductsListInfo(product, mainProduct, hasCoupon, t)}</div>
                </div>
                {viewDetailedPrices && !isExternalManagement && (
                  <div className="price-details">
                    <div className="price-detail">
                      <Text className="price-detail-title">{t("otherProducts.priceLabel")}</Text>
                      <Text className="price-detail-value">{formatCurrency(product?.price_details.price_wo_vat)}</Text>
                    </div>
                    <div className="price-detail">
                      <Text className="price-detail-title">{t("otherProducts.vatLabel", { vat: product?.price_details.vat_tax })}</Text>
                      <Text className="price-detail-value">{formatCurrency(product?.price_details.vat_value)}</Text>
                    </div>
                    {colSize !== "xs" && (
                      <div className="price-detail">
                        <Text className="price-detail-title">{t("otherProducts.totalLabel")}</Text>
                        <Text className="price-detail-value">{formatCurrency(product?.price)}</Text>
                      </div>
                    )}
                  </div>
                )}
              </div>
              {product?.n_payments > 1 && hasCoupon !== true && (
                <div className="installments_disclaimer">
                  <Tooltip title={totalPaymentTooltip(selectedOffer, coupon, t)}>
                    <Text className="text">{t("otherProducts.installmentsDisclaimer", { total: totalPayment(selectedOffer, coupon) })}</Text>
                  </Tooltip>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OtherProducts;
